import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/goro/git/falconet/src/components/ThemeRegistry/ThemeRegistry.tsx");
